import TextLink from "../components/TextLink";
import { motion } from "framer-motion"
import MobileFooter from '../components/MobileFooter';

function Image(data) {
    return (
        <figure>
        <img src={data.src} />
        <figcaption className="is-size-7">
            {data.children}
        </figcaption>
    </figure>
    )
}
function About(props) {
    return (
    <motion.section className="pt-4 pl-4 pb-4 pr-4" {...props.framer.slide}>

        <div className="content is-serif is-size-4">
            <p>
                Drifting offer some additional ways to be experienced. 
            </p>
            <p className="has-text-centered is-uppercase">
                Theater Mode
            </p>
            <p className="content is-serif is-size-4">
            Drifting been designed in a vertical format, but an alternative display mode is available for horizontal screens. The entire screen space is filled by putting two iterations of the same token next to each other.
            </p>
            <div className="field">
                <label className="label has-text-centered is-size-7">Insert your Token ID or <span className="is-underlined is-clickable" >generate a random one</span>
                </label>
                <div className="control ">
                    <input className="input has-text-centered is-code is-size-4" type="text" placeholder="286000000" />
                </div>
             </div>
            <br/>

            <p className="has-text-centered is-uppercase">
                High Resolution Mode
            </p>
            <p className="content is-serif is-size-4">
            Each piece is also visible in high resolution. A certain visual softness is typical of analog video, but there are certain mints that benefit from an higher resolution visualization. The choice between the different visualization is really up to the collector. Note: this might look slow and choppy on older computers and devices.
            </p>
            <div className="field">
                <label className="label has-text-centered is-size-7">Insert your Token ID or <span className="is-underlined is-clickable" >generate a random one</span>
                </label>
                <div className="control ">
                    <input className="input has-text-centered is-code is-size-4" type="text" placeholder="286000000" />
                </div>
             </div>
             <br/>

            <p className="has-text-centered is-uppercase">
                Fullscreen Mode
            </p>
            <p className="content is-serif is-size-4">
            This view mode is a solution to the avoid black bars if the project has to be displayed on a vertical screen with a different aspect ratio. Please be <em>extremely</em> careful using this mode as it distorts the original work in unintended ways.
            And please never use this view mode on horizontal displays, the <em>theater mode</em> is made especially for that purpose.
            </p>
            <div className="field">
                <label className="label has-text-centered is-size-7">Insert your Token ID or <span className="is-underlined is-clickable" >generate a random one</span>
                </label>
                <div className="control ">
                    <input className="input has-text-centered is-code is-size-4" type="text" placeholder="286000000" />
                </div>
             </div>
             <br/>

            <p className="has-text-centered is-uppercase">
                Quick Export
            </p>
            <p className="content is-serif is-size-4">
            This is a very beta tool to export a short preview video of 30 seconds from any Drifting piece, optimized to be shared on social media. I'm working to improve te quality of the output. Note: it's only been tested on MacOSX with Chrome, Brave and Firefox.
             
            </p>
            <div className="field">
                <label className="label has-text-centered is-size-7">Insert your Token ID or <span className="is-underlined is-clickable" >generate a random one</span>
                </label>
                <div className="control ">
                    <input className="input has-text-centered is-code is-size-4" type="text" placeholder="286000000" />
                </div>
             </div>
             <br/>

           
        </div>
        {props.mobile&&<MobileFooter {...props} />}
    </motion.section> 

    )
}

export default About;
